import { useState, useEffect, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import paths from "@icarius-router/paths";
import { RESET_ROWS } from "../actionTypes";
import {
  getGeoanalysisGroupsFromServer,
  getGeoanalysisQueriesFromServer,
} from "../actions";
import {
  getIsLoading,
  getQueryGroups,
  getQueries,
  getGroupsToFilter,
} from "../selectors";

const useGeoanalysis = () => {

  const [gridIsOpen, setGridIsOpen] = useState(false);
  const [group, setGroup] = useState("");
  const [groupName, setGroupName] = useState('');
  const [queryPreset, setQueryPreset] = useState('');
  const [userPreset, setUserPreset] = useState('');

  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const queries = useSelector(getQueries);
  const queryGroups = useSelector(getQueryGroups);
  const groupsToFilter = useSelector(getGroupsToFilter);
  const isLoading = useSelector(getIsLoading);

  useEffect(() => {
    dispatch(getGeoanalysisGroupsFromServer());
  }, [dispatch])

  const handleOpenGrid = useCallback((newGroup, newGroupName) => {
    setGridIsOpen(true);
    setGroup(newGroup);
    setGroupName(newGroupName || newGroup);
    dispatch(getGeoanalysisQueriesFromServer(newGroup));
  }, [dispatch])

  const handleCloseGrid = () => {
    setGridIsOpen(false);
    setGroup("");
    dispatch({ type: RESET_ROWS });
  }

  useEffect(() => {
    if (location.search) {
      const groupFromParams = new URLSearchParams(location.search).get("group");
      const groupNameFromParams = new URLSearchParams(location.search).get("groupName"); // para los de userMenu, donde el groupName es distinto al group
      const queryFromParams = new URLSearchParams(location.search).get("queryCode");
      const userFromParams = new URLSearchParams(location.search).get("employeeCode");

      setUserPreset(userFromParams);
      setQueryPreset(queryFromParams);
      handleOpenGrid(groupFromParams, groupNameFromParams);

      history.replace({
        pathname: paths.geoanalysis,
        search: '',
      });
    }
  }, [location.search, history, handleOpenGrid])

  const filteredGroups = useMemo(() => {
    return queryGroups.filter((group) => !groupsToFilter.includes(group.toLowerCase()))
  }, [queryGroups, groupsToFilter])

  const isFromHiddenGroup = groupsToFilter.includes(group.toLowerCase());

  const state = {
    gridIsOpen,
    group,
    groupName,
    queryPreset,
    userPreset,
  }

  const handlers = {
    handleOpenGrid,
    handleCloseGrid,
  }

  return {
    groups: filteredGroups,
    state,
    handlers,
    isLoading,
    isFromHiddenGroup,
    queries,
  }
}

export default useGeoanalysis;
